import React, { useEffect, useState } from "react";
import BreadCrumbBanner from "../../component/BreadCrumbBanner";
import facilitiesAPI from "../../api/facilitiesApi";

const MiddayMeal = () => {
  const [midDay, setMidDay] = useState([]);

  useEffect(() => {
    fetchMusicRoom();
  }, []);

  const fetchMusicRoom = async () => {
    const res = await facilitiesAPI.mid_day();

    if (res.code === 200) {
      const result = res.data;
      setMidDay(result);
    }
  };
  const midDayData = midDay?.["mid-day"]?.[0];
  return (
    <>
      {/* BreadCrump Section */}
      <BreadCrumbBanner
        title="Mid-day Meal"
        backgroundImage={`${process.env.PUBLIC_URL}/assets/img/about-top2.webp`}
      />

      {midDay && (
        <>
          <section className="midday-meal-section bg-light py-5">
            <div className="container">
              <div className="row align-items-center g-5">
                {/* LEFT : CONTENT */}
                <div className="col-lg-6 animate__animated animate__fadeInLeft order-lg-1 order-2">
                  <div className="midday-meal-content">
                    <span className="mrv-subtitle">{midDayData?.subtitle}</span>
                    <h2 className="mrv-title">{midDayData?.title}</h2>
                    <p className="midday-meal-desc">
                      {midDayData?.shortdescription}
                    </p>
                    <div className="midday-meal">
                      {midDayData?.listings?.map((item, index) => (
                        <div className="meal-info-card">
                          <img className="library-icon" src={item.icon} loading="lazy" />
                          <div>
                            <h6>{item.listingtitle}</h6>
                            <p>{item.listingdescription}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                {/* RIGHT : IMAGE */}
                <div className="col-lg-6 animate__animated animate__fadeInRight order-lg-2 order-1">
                  <div className="midday-meal-image-box">
                    <img
                      src={midDayData?.image}
                      alt="Mid Day Meal"
                      loading="lazy"
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="meal-nutrition-section py-5">
            <div className="container">
              <div className="row align-items-center g-5">
                <div className="col-lg-6 order-2">
                  <h2 className="mrv-title">
                   {midDayData?.studenttitle}
                  </h2>
                  <p  dangerouslySetInnerHTML={{
                      __html: midDayData?.studentdescription || "",
                    }}/>
                </div>

                <div className="col-lg-6 order-1">
                  <img
                    src={midDayData?.studentimage}
                    alt="Healthy Food"
                    className="img-fluid rounded"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </>
  );
};

export default MiddayMeal;
